


export default {
    methods: {
        isPermission(key) {
            let  permissions =  this.$store.getters.getPermissions ;
            return  permissions.length ? permissions.includes(key) : false;
        }
    }
}
